import { useState, useEffect } from 'react';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { useSpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/page-ready-state/index.tsx';
import type { Board } from './types.tsx';

type UseUserBoardIdReturn = [number | null, string | null];

export const useUserBoardId = (shouldRun: boolean): UseUserBoardIdReturn => {
	const [{ isReady }] = useSpaStatePageReady();
	const [userBoard, setUserBoard] = useState<Board | null>(null);
	const shouldFetch = shouldRun || isReady;
	useEffect(() => {
		if (!shouldFetch || userBoard) return;

		setUserBoard(null);
		const requestUrl = '/rest/greenhopper/1.0/rapidviews/recent?maxResults=1&userBoard=true';
		performGetRequest(requestUrl)
			.then((result) => {
				const [board] = result.views;
				if (board) setUserBoard(board);
			})
			.catch(() => {
				// user board fetch failed, ignore
			});
	}, [shouldFetch, userBoard, setUserBoard]);

	return userBoard && userBoard.location
		? [userBoard.id, userBoard.location.accountId]
		: [null, null];
};

export type UseUserBoardIdType = typeof useUserBoardId;
